import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { CONFIGURATION } from "../../../../app.constants";
import { ElearningCourse, ElearningModule, Pagination } from "../../../../models";
import { Observable } from "rxjs/Observable";
import { HttpDataService } from "../../../../services/shared";
@Injectable()
export class ELearningService {

    constructor(private httpData: HttpDataService) {
    }

    public GetElearningCourses(): Observable<ElearningCourse[]> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}elearning/Courses`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <ElearningCourse[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetElearningModules(cateogryId: number): Observable<ElearningModule[]> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}elearning/Modules?$filter=CategoryId eq ` + cateogryId;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <ElearningModule[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetElearningCourseResults(courseId: number, pagination: Pagination, sortOrder: string, sortColumn: string): Observable<Response> {
        let order: string = "&$orderby=" + sortColumn + " " + sortOrder;
        let skip: any = (pagination.currentPage - 1) * pagination.itemsPerPage;
        let dataUrl = CONFIGURATION.baseUrls.apiUrl + "elearning/CourseResults?$filter=CourseId eq " + courseId + "&$skip=" + skip + "&$top=" + pagination.itemsPerPage + "&$count=true" + order;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/reports/elearning/elearning.service.ts